<template>
  <div class="bg-white header-bar flex justify-center p-4 shadow-md">
    <div class="flex items-center justify-between w-full content-wrapper">
      <div>
        <img
          class="hidden sm:block"
          src="@/assets/images/logo.svg"
          alt="XING Logo"
        />
        <img
          class="sm:hidden"
          src="@/assets/images/logo-mobile.svg"
          alt="XING Logo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { addTrackingParamToURL } from "@/utils/tracking";

export default {
  name: "HeaderLayout",
  methods: {
    getTrackingURL(url) {
      return addTrackingParamToURL(url);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .content-wrapper {
    max-width: 100% !important;
  }
}

@media (min-width: 1250px) {
  .header-bar {
    font-size: 18px;
    line-height: 18px;

    & .content-wrapper {
      max-width: 1250px !important;
    }
  }
}
</style>
